<template>
  <div class="pagination">
    <a-pagination
      :showTotal="total => `共 ${total}条数据`"
      v-model:current="pagination.pageNum"
      v-model:pageSize="pagination.pageSize"
      :total="pagination.total"
      showSizeChanger
      @change="initList"
    />
  </div>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    const initState = inject('initState')

    return {
      ...toRefs(initState)
    }
  }
}
</script>
<style scoped>
.pagination {
  display: flex;
  flex-direction: row-reverse;
  background: #fff;
  padding: 20px;
}
</style>
